import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import SHIPMENT_ITEM_STATUSES from 'domains/customer-shipment-item/constants/customer-shipment-item-status'

const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const CustomerShipmentItemStatusBadge = ({ status }) => {

  const colorMap = {

    [SHIPMENT_ITEM_STATUSES.PENDING]   : 'warning',
    [SHIPMENT_ITEM_STATUSES.PACKED]    : 'info',
    [SHIPMENT_ITEM_STATUSES.CANCELLED] : 'danger',
    [SHIPMENT_ITEM_STATUSES.SHIPPED]   : 'success'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

CustomerShipmentItemStatusBadge.propTypes = propTypes

export default CustomerShipmentItemStatusBadge